var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CabeceraTabla", {
        attrs: { permisoAccion: _vm.accionCrear },
        scopedSlots: _vm._u([
          {
            key: "izquierda",
            fn: function() {
              return [
                _c("BuscadorMantenedor", {
                  attrs: { filter: _vm.funcionFiltrar }
                })
              ]
            },
            proxy: true
          },
          {
            key: "centro",
            fn: function() {
              return [
                _c("ExportarAgGridButton", {
                  attrs: {
                    permisoAccion: _vm.accionExportar,
                    "column-defs": _vm.enrichedGridOptions
                      ? _vm.enrichedGridOptions.columnDefs
                      : _vm.gridOptions.columnDefs,
                    "row-data": _vm.lstContratosProveedores,
                    "exported-file-name": "ConfiguracionDeContrato"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "derecha",
            fn: function() {
              return [
                _c("CrearButton", {
                  attrs: { permisoAccion: _vm.accionCrear },
                  on: {
                    click: function($event) {
                      return _vm.handleCrearClick()
                    }
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("MantenedorGridTodos", {
        attrs: {
          "grid-options": _vm.gridOptions,
          "funcionalidad-id": _vm.funcionalidad,
          "test-id": "ContratoProveedor"
        },
        on: {
          gridOptionsEnriched: function($event) {
            _vm.enrichedGridOptions = $event
          }
        }
      }),
      _c("ConfirmacionEliminar", {
        attrs: {
          show: _vm.isConfirmacionEliminarActivo,
          titulo: this.$t("mensajes.crud.eliminar.titulo", {
            entidad: "Configuración de Contrato",
            nombreEntidad: _vm.contratoProveedorSeleccionado
              ? _vm.contratoProveedorSeleccionado.nombre
              : ""
          }),
          mensaje: { entidad: "la Configuración de Contrato" }
        },
        on: {
          aceptar: _vm.handleConfirmacionEliminar,
          cancelar: _vm.cerrarModalCrud
        }
      }),
      _c("Confirmation", {
        attrs: {
          show: _vm.noPermiteEliminarConfirm,
          titulo: this.$t("mensajes.crud.eliminar.titulo", {
            entidad: "Configuración de Contrato",
            nombreEntidad: _vm.contratoProveedorSeleccionado
              ? _vm.contratoProveedorSeleccionado.nombre
              : ""
          }),
          mensaje:
            "El Contrato a eliminar tiene asociaciones activas, por esta razón no se puede eliminar.",
          mostrarBoton: false
        },
        on: {
          modalConfirmationEmit: function($event) {
            _vm.noPermiteEliminarConfirm = false
          }
        }
      }),
      _vm.isModalCrearActivo
        ? _c("CrearContratoProveedorModal", {
            on: { cerrar: _vm.cerrarModalCrud, crear: _vm.handleCrearOrEditar }
          })
        : _vm._e(),
      _vm.isModalEditarActivo
        ? _c("EditarContratoProveedorModal", {
            attrs: { idContratoProveedor: _vm.idContratoProveedor },
            on: {
              cerrar: _vm.cerrarModalCrud,
              guardar: _vm.handleCrearOrEditar
            }
          })
        : _vm._e(),
      _vm.isModalVerActivo
        ? _c("VerContratoProveedorModal", {
            attrs: { idContratoProveedor: _vm.idContratoProveedor },
            on: { cerrar: _vm.cerrarModalCrud }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }